// REISOR_STAGE22P2M_DRIVER_DISPATCHER_SUPPORT_CHAT_TG_NOTIFY_V1
// Driver support chat API. This is driver <-> dispetcher support, not order/client chat.

const API_BASE = (() => {
  const explicit = import.meta.env.VITE_AUTH_BASE;
  const base = String(explicit || import.meta.env.VITE_API_BASE || "/api").trim().replace(/\/+$/g, "");
  if (/\/api\/v2$/i.test(base)) return base.replace(/\/api\/v2$/i, "/api");
  if (/\/v2$/i.test(base)) return base.replace(/\/v2$/i, "");
  return base || "/api";
})();

function readTokenFrom(storage) {
  try {
    const keys = ["driverToken", "drvToken", "driver_token", "token", "authToken"];
    for (const k of keys) {
      const v = storage.getItem(k);
      if (v) return v;
    }
    for (const k of ["driverAuth", "auth", "driver_data", "driver"]) {
      const raw = storage.getItem(k);
      if (!raw) continue;
      const obj = JSON.parse(raw);
      const token = obj?.token || obj?.driverToken || obj?.authToken || obj?.accessToken || obj?.jwt;
      if (token) return token;
    }
  } catch {}
  return "";
}

function getDriverToken() {
  try {
    return readTokenFrom(localStorage) || readTokenFrom(sessionStorage) || "";
  } catch {
    return "";
  }
}

function bearer(token) {
  const t = String(token || getDriverToken() || "").trim();
  if (!t) return "";
  return /^bearer\s+/i.test(t) ? t : `Bearer ${t}`;
}

async function http(method, path, payload, token) {
  const headers = { "Content-Type": "application/json" };
  const auth = bearer(token);
  if (auth) headers.Authorization = auth;

  const res = await fetch(API_BASE + path, {
    method,
    headers,
    credentials: "include",
    body: method === "GET" ? undefined : JSON.stringify(payload || {}),
  });

  let data = {};
  const text = await res.text().catch(() => "");
  try { data = text ? JSON.parse(text) : {}; } catch { data = { message: text }; }

  if (!res.ok) {
    throw new Error(data?.message || data?.error || `HTTP ${res.status}`);
  }

  return data;
}

export function listDriverSupportThreads(token) {
  return http("GET", "/driver/support/threads", null, token);
}

export function getDriverSupportThread(threadId, token) {
  const id = String(threadId || "").trim();
  if (!id) throw new Error("THREAD_ID_REQUIRED");
  return http("GET", `/driver/support/threads/${encodeURIComponent(id)}`, null, token);
}

export function createDriverSupportThread({ text, orderId = "", priorityEventId = "" } = {}, token) {
  return http("POST", "/driver/support/threads", { text, orderId, priorityEventId }, token);
}

export function sendDriverSupportMessage(threadId, text, token) {
  const id = String(threadId || "").trim();
  if (!id) throw new Error("THREAD_ID_REQUIRED");
  return http("POST", `/driver/support/threads/${encodeURIComponent(id)}/messages`, { text }, token);
}
